import { ReactNode } from "react";

function ConditionalWrapper({
    condition,
    wrapper,
    children,
}: {
    condition: boolean;
    wrapper: (children: ReactNode) => ReactNode;
    children: ReactNode;
}) {
    return condition ? wrapper(children) : children;
}

export default ConditionalWrapper;
